import ComponentLayout from "../../../../src/layouts/component-layout";
import anatomy from "../../../../content/components/Footnotes/images/anatomy.png";
import doPosition from "../../../../content/components/Footnotes/images/do-position.png";
import doReturnLinks from "../../../../content/components/Footnotes/images/do-use-return-urls.png";
import dontReturnLinks from "../../../../content/components/Footnotes/images/dont-use-return-urls.png";
import doUseDisclaimer from "../../../../content/components/Footnotes/images/do-use-disclaimer.png";
import dontUseDisclaimer from "../../../../content/components/Footnotes/images/dont-use-disclaimer.png";
import * as React from 'react';
export default {
  ComponentLayout,
  anatomy,
  doPosition,
  doReturnLinks,
  dontReturnLinks,
  doUseDisclaimer,
  dontUseDisclaimer,
  React
};